export const courseCategories = (course) => {
  const names = course.categories?.length ? course.categories : (course.category ? [course.category] : []);
  return [...new Set([...names, ...(course.trainingsclub_eligible ? ["Trainingsclub"] : [])].map((name) => name.trim()).filter((name) => name && name !== "Alle"))];
};

export const categoryTestKey = (category) => category.system_key || category.name;